import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
// import '../styles/Home.css';

function Home() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "School Principal",
      image: "/api/placeholder/100/100",
      text: "The comprehensive curriculum and hands-on approach have transformed how our students learn technology."
    },
    {
      id: 2,
      name: "Michael Chen",
      role: "Parent",
      image: "/api/placeholder/100/100",
      text: "My child has shown remarkable progress in understanding computer concepts through these engaging books."
    },
    // Add more testimonials
  ];

  const stats = [
    { number: "10K+", label: "Students Trained" },
    { number: "500+", label: "Schools" },
    { number: "50+", label: "Workshops" },
    { number: "95%", label: "Satisfaction Rate" }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => 
        prev === testimonials.length - 1 ? 0 : prev + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content animate-on-scroll">
          <h1>Empowering Future Innovators</h1>
          <p>Discover our comprehensive educational solutions in computer science and digital technologies</p>
          <div className="hero-buttons">
            <Link to="/products" className="cta-button primary">Explore Books</Link>
            <Link to="/workshops" className="cta-button secondary">Join Workshops</Link>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card animate-on-scroll">
              <h2>{stat.number}</h2>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Books Preview Section */}
      <section className="books-preview-section">
        <h2>Educational Books</h2>
        <p>Comprehensive computer education from Grade 1 to 10</p>
        <div className="books-preview">
          {/* Add book preview cards */}
          <Link to="/products" className="view-all-btn">View All Books</Link>
        </div>
      </section>

      {/* Workshops Preview */}
      <section className="workshops-preview-section">
        <h2>Upcoming Workshops</h2>
        <p>Join our hands-on learning experiences</p>
        <div className="workshop-preview-grid">
          {/* Add workshop preview cards */}
          <Link to="/workshops" className="view-all-btn">Browse All Workshops</Link>
        </div>
      </section>

      {/* Platform Preview */}
      <section className="platform-preview-section">
        <div className="platform-content">
          <h2>Build Websites with Blocks</h2>
          <p>Create stunning websites using our innovative block-based platform</p>
          <Link to="/platform" className="try-demo-btn">Try Demo</Link>
        </div>
        <div className="platform-preview-image">
          {/* Add platform preview image */}
        </div>
      </section>

      {/* Partners & Supporters */}
      <section className="partners-section">
        <h2>Our Partners & Supporters</h2>
        <div className="partners-grid">
          {/* Add partner logos */}
          <Link to="/partners" className="view-all-btn">View All Partners</Link>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <h2>What People Say</h2>
        <div className="testimonials-carousel">
          {testimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id} 
              className={`testimonial-card ${index === currentTestimonial ? 'active' : ''}`}
            >
              <div className="testimonial-content">
                <p>{testimonial.text}</p>
                <div className="testimonial-author">
                  <img src={testimonial.image} alt={testimonial.name} />
                  <div>
                    <h4>{testimonial.name}</h4>
                    <p>{testimonial.role}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <h2>Ready to Start Learning?</h2>
        <p>Join thousands of students in their journey to master technology</p>
        <div className="cta-buttons">
          <Link to="/contact" className="cta-button primary">Contact Us</Link>
          <Link to="/products" className="cta-button secondary">Browse Products</Link>
        </div>
      </section>
    </div>
  );
}

export default Home;